import { ChangeDetectorRef, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { StripeReadersHttpService } from '../../../../core/stripe-readers/_services/stripe-readers-http.service';
import { SettingsHttpService } from '../../../../core/settings/_services/settings-http.service';
import { MachineRouteService } from '../machine-route.service';
var CardReaderComponent = /** @class */ (function () {
    function CardReaderComponent(stripeReadersHttp, snackBar, settingsHttp, ngZone, cdr, route, machineRouteService) {
        this.stripeReadersHttp = stripeReadersHttp;
        this.snackBar = snackBar;
        this.settingsHttp = settingsHttp;
        this.ngZone = ngZone;
        this.cdr = cdr;
        this.route = route;
        this.machineRouteService = machineRouteService;
        this.machineId = '';
        this.machineName = '';
        this.mode = 'none';
        this.isLoading = false;
        this.isBusy = false;
        this.errorMessage = '';
        this.reader = null;
        this.machineSerial = '';
        this.machineStatus = null;
        this.isStatusLoading = false;
        this.confirmRemove = false;
        this.confirmReregister = false;
        // Shows the success banner on the assigned view right after a registration.
        this.justRegistered = false;
        // A reader taken off this machine that Stripe failed to delete; it can't be registered again until it is.
        this.undeletedReaderId = '';
        // The campus a new reader is registered to, and the one the user confirmed.
        this.campusResult = null;
        this.isCampusLoading = false;
        this.confirmedCampusId = null;
        this.registrationCode = '';
    }
    CardReaderComponent.prototype.ngOnInit = function () {
        var machine = this.machineRouteService.getMachine(this.route);
        if (!machine) {
            return;
        }
        this.machineId = String(machine.machine_id || '');
        this.machineName = String(machine.machine_name || '');
        this.machineSerial = String(machine.serial_no || '');
        this.loadCampus();
        this.loadReaders();
    };
    Object.defineProperty(CardReaderComponent.prototype, "campus", {
        get: function () {
            return this.campusResult ? this.campusResult.campus : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardReaderComponent.prototype, "campusName", {
        get: function () {
            return (this.campus && this.campus.name) || 'this campus';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardReaderComponent.prototype, "readerLabel", {
        // Matches the label the server gives the reader in Stripe.
        get: function () {
            var name = this.machineName.trim();
            return name && name !== this.machineId ? name + " - " + this.machineId : this.machineId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardReaderComponent.prototype, "campusAddressLines", {
        get: function () {
            var address = this.campus && this.campus.address;
            if (!address) {
                return [];
            }
            var cityLine = [[address.city, address.state].filter(Boolean).join(', '), address.postal_code]
                .filter(Boolean)
                .join(' ');
            return [address.line1, address.line2, cityLine, address.country].filter(Boolean);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardReaderComponent.prototype, "readerInWrongLocation", {
        // Stripe cannot move a reader between locations, so one registered elsewhere has to be re-registered.
        get: function () {
            var campusLocationId = this.reader && this.reader.assignment
                ? this.reader.assignment.campus_stripe_location_id
                : '';
            return Boolean(this.reader &&
                this.reader.in_stripe !== false &&
                campusLocationId &&
                this.reader.location_id &&
                this.reader.location_id !== campusLocationId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardReaderComponent.prototype, "statusIcon", {
        get: function () {
            switch (this.machineStatus && this.machineStatus.kind) {
                case 'in_use':
                    return 'check_circle';
                case 'pending':
                    return 'schedule';
                case 'mismatch':
                case 'stripe_on':
                    return 'error_outline';
                default:
                    return 'help_outline';
            }
        },
        enumerable: true,
        configurable: true
    });
    // onDone runs once the list has loaded (or failed), before the view updates.
    CardReaderComponent.prototype.loadReaders = function (nextMode, onDone) {
        var _this = this;
        this.isLoading = true;
        this.stripeReadersHttp.listReaders().subscribe({
            next: function (response) {
                var readers = response && response.data && Array.isArray(response.data.readers) ? response.data.readers : [];
                _this.reader = readers.find(function (reader) { return Boolean(reader.assignment && reader.assignment.machine_id === _this.machineId); }) || null;
                var fallbackMode = _this.reader ? 'assigned' : 'none';
                _this.mode = nextMode && (nextMode !== 'assigned' || _this.reader) ? nextMode : fallbackMode;
                _this.isLoading = false;
                if (onDone) {
                    onDone();
                }
                _this.cdr.markForCheck();
                _this.loadMachineStatus();
            },
            error: function (error) {
                _this.isLoading = false;
                if (onDone) {
                    onDone();
                }
                _this.cdr.markForCheck();
                _this.errorMessage = _this.failureMessage(error, 'Failed to load Stripe card readers.');
            }
        });
    };
    CardReaderComponent.prototype.loadCampus = function () {
        var _this = this;
        this.isCampusLoading = true;
        this.stripeReadersHttp.getMachineCampus(this.machineId).subscribe({
            next: function (response) {
                _this.isCampusLoading = false;
                _this.cdr.markForCheck();
                _this.campusResult = response && response.data ? response.data : null;
                // A confirmation only counts for the campus that was shown.
                if (!_this.campus || _this.campus.campus_id !== _this.confirmedCampusId) {
                    _this.confirmedCampusId = null;
                    if (_this.mode === 'register') {
                        _this.mode = 'confirm';
                    }
                }
            },
            error: function (error) {
                _this.isCampusLoading = false;
                _this.cdr.markForCheck();
                _this.errorMessage = _this.failureMessage(error, 'Failed to load the machine’s campus.');
            }
        });
    };
    // Asks the user to confirm the campus, with fresh data in case it was just changed elsewhere.
    CardReaderComponent.prototype.startRegistration = function () {
        this.resetForms();
        this.confirmedCampusId = null;
        this.mode = 'confirm';
        this.loadCampus();
    };
    CardReaderComponent.prototype.confirmCampus = function () {
        if (!this.campus || !this.campusResult || !this.campusResult.address_complete) {
            return;
        }
        this.confirmedCampusId = this.campus.campus_id;
        this.mode = 'register';
    };
    CardReaderComponent.prototype.cancel = function () {
        this.resetForms();
        this.confirmedCampusId = null;
        this.mode = this.reader ? 'assigned' : 'none';
    };
    CardReaderComponent.prototype.registerReader = function () {
        var _this = this;
        var registrationCode = this.normalizedRegistrationCode();
        if (!registrationCode) {
            this.errorMessage = 'Enter the registration code shown on the reader.';
            return;
        }
        if (!this.confirmedCampusId) {
            this.mode = 'confirm';
            return;
        }
        this.isBusy = true;
        this.errorMessage = '';
        this.stripeReadersHttp
            .registerReader({
            registration_code: registrationCode,
            machine_id: this.machineId,
            confirmed_campus_id: this.confirmedCampusId
        })
            .subscribe({
            // Stay on the busy form until the reader list has the new reader, then switch views
            // in one step; clearing the code earlier showed an empty form for a moment.
            next: function () { return _this.loadReaders('assigned', function () {
                _this.finishRegistrationForm();
                _this.justRegistered = true;
            }); },
            error: function (error) {
                var details = _this.failureDetails(error);
                _this.errorMessage = _this.failureMessage(error, 'Failed to register the card reader.');
                if (details.assignment_saved) {
                    _this.loadReaders('assigned', function () { return _this.finishRegistrationForm(); });
                    return;
                }
                _this.isBusy = false;
                _this.cdr.markForCheck();
                if (!details.registration_completed) {
                    // The campus may have changed since it was confirmed; this sends the user back to confirm it.
                    _this.loadCampus();
                }
                // Registered but not assigned: the form keeps the same code, and retrying reuses the same reader.
            }
        });
    };
    CardReaderComponent.prototype.retrySync = function () {
        var _this = this;
        if (!this.reader) {
            return;
        }
        this.justRegistered = false;
        this.isBusy = true;
        this.errorMessage = '';
        this.stripeReadersHttp.assignReader(this.reader.stripe_reader_id, { machine_id: this.machineId }).subscribe({
            next: function () {
                _this.isBusy = false;
                _this.cdr.markForCheck();
                _this.snackBar.open('Settings sent to the machine.', '', { duration: 5000 });
                _this.loadReaders('assigned');
            },
            error: function (error) {
                _this.isBusy = false;
                _this.cdr.markForCheck();
                _this.errorMessage = _this.failureMessage(error, 'Failed to send settings to the machine.');
            }
        });
    };
    // Takes the reader off this machine and deletes it in Stripe, so it can be registered again anywhere.
    CardReaderComponent.prototype.removeReader = function () {
        if (this.reader) {
            this.deleteReader(this.reader.stripe_reader_id, 'Reader removed and deleted from Stripe. The machine will restart in about a minute with card payments off.', 'none');
        }
    };
    // Stripe can't move a reader between locations; deleting it lets it be registered to this campus.
    CardReaderComponent.prototype.reregisterReader = function () {
        if (!this.reader) {
            return;
        }
        this.deleteReader(this.reader.stripe_reader_id, 'Reader deleted from Stripe. The machine will restart in about a minute. Confirm the campus, then enter a new code from the reader.', 'confirm');
    };
    CardReaderComponent.prototype.retryDelete = function () {
        if (this.undeletedReaderId) {
            this.deleteReader(this.undeletedReaderId, 'Reader deleted from Stripe.', this.reader ? 'assigned' : 'none');
        }
    };
    CardReaderComponent.prototype.loadMachineStatus = function () {
        var _this = this;
        if (!this.machineSerial) {
            this.machineStatus = {
                kind: 'unavailable',
                title: 'Machine settings unavailable',
                detail: 'This machine has no serial number, so it cannot receive card reader settings.'
            };
            return;
        }
        this.isStatusLoading = true;
        // getShadowData resolves an Amplify promise outside Angular's zone; re-enter it so the view updates.
        this.settingsHttp.getShadowData(this.machineSerial).subscribe({
            next: function (shadow) { return _this.ngZone.run(function () {
                _this.isStatusLoading = false;
                _this.cdr.markForCheck();
                var doc = null;
                try {
                    doc = shadow && shadow.payload ? JSON.parse(shadow.payload) : null;
                }
                catch (e) {
                    doc = null;
                }
                _this.machineStatus = _this.describeMachineStatus(doc);
            }); },
            error: function () { return _this.ngZone.run(function () {
                _this.isStatusLoading = false;
                _this.cdr.markForCheck();
                _this.machineStatus = {
                    kind: 'unavailable',
                    title: 'Machine settings unavailable',
                    detail: 'The machine’s IoT settings could not be read. It may not be set up in AWS IoT yet.'
                };
            }); }
        });
    };
    CardReaderComponent.prototype.readerName = function (reader) {
        return reader ? reader.label || reader.serial_number || reader.stripe_reader_id : '';
    };
    CardReaderComponent.prototype.formatDeviceType = function (deviceType) {
        return String(deviceType || 'Card reader')
            .split('_')
            .map(function (part) { return part.toUpperCase() === part ? part : part.charAt(0).toUpperCase() + part.slice(1); })
            .join(' ');
    };
    CardReaderComponent.prototype.isOnline = function (reader) {
        return String(reader && reader.status).toLowerCase() === 'online';
    };
    CardReaderComponent.prototype.deleteReader = function (stripeReaderId, successMessage, nextMode) {
        var _this = this;
        this.justRegistered = false;
        this.isBusy = true;
        this.errorMessage = '';
        this.stripeReadersHttp.deregisterReader(stripeReaderId).subscribe({
            next: function () {
                _this.isBusy = false;
                _this.cdr.markForCheck();
                _this.confirmRemove = false;
                _this.confirmReregister = false;
                _this.undeletedReaderId = '';
                _this.snackBar.open(successMessage, '', { duration: 6000 });
                if (nextMode === 'confirm') {
                    _this.loadCampus();
                }
                _this.loadReaders(nextMode);
            },
            error: function (error) {
                _this.isBusy = false;
                _this.cdr.markForCheck();
                _this.confirmRemove = false;
                _this.confirmReregister = false;
                var details = _this.failureDetails(error);
                _this.errorMessage = _this.failureMessage(error, 'Failed to delete the reader from Stripe.');
                _this.undeletedReaderId = details.assignment_removed && !details.deleted_in_stripe ? stripeReaderId : '';
                _this.loadReaders();
            }
        });
    };
    CardReaderComponent.prototype.describeMachineStatus = function (doc) {
        var state = (doc && doc.state) || {};
        var desired = state.desired || {};
        var reported = state.reported || {};
        var reportedMeta = (doc && doc.metadata && doc.metadata.reported) || {};
        var reportedAt = reportedMeta.stripe_reader_id && reportedMeta.stripe_reader_id.timestamp
            ? new Date(reportedMeta.stripe_reader_id.timestamp * 1000).toLocaleString()
            : '';
        var usesStripe = function (fields, readerId) {
            return fields.payment_provider === 'stripe' &&
                fields.stripe_sidecar_enabled === true &&
                Boolean(fields.stripe_reader_id) &&
                (!readerId || fields.stripe_reader_id === readerId);
        };
        if (!this.reader) {
            if (usesStripe(reported) || usesStripe(desired)) {
                var readerId_1 = reported.stripe_reader_id || desired.stripe_reader_id;
                return {
                    kind: 'stripe_on',
                    title: 'Card payments are still on',
                    detail: "No reader is assigned here, but the machine is set to use reader " + readerId_1 + "."
                };
            }
            return { kind: 'off', title: 'Card payments are off', detail: '' };
        }
        var readerId = this.reader.stripe_reader_id;
        if (usesStripe(reported, readerId)) {
            return {
                kind: 'in_use',
                title: 'Machine is using this reader',
                // AWS stamps a reported field only when the machine writes it, which can predate this assignment
                // when the machine already had these settings.
                detail: reportedAt ? "The machine last reported this reader on " + reportedAt + "." : ''
            };
        }
        if (usesStripe(desired, readerId)) {
            var otherReader = reported.stripe_reader_id && reported.stripe_reader_id !== readerId
                ? " It still reports reader " + reported.stripe_reader_id + "."
                : '';
            return {
                kind: 'pending',
                title: 'Waiting for the machine to apply the settings',
                // The machine restarts about a minute after it gets new card reader settings, so this is normal at first.
                detail: "The settings were sent, but the machine has not confirmed them." + otherReader + " It restarts to apply them, which takes a few minutes. If this lasts longer, it may be offline."
            };
        }
        var configuredReader = desired.stripe_reader_id
            ? " It is set to reader " + desired.stripe_reader_id + "."
            : '';
        var nextStep = this.reader.in_stripe === false
            ? ''
            : ' Re-send the settings so the machine uses this reader.';
        return {
            kind: 'mismatch',
            title: 'Machine settings don’t match this reader',
            detail: ("" + configuredReader + nextStep).trim()
        };
    };
    // Codes are lowercase words joined by hyphens; fix the usual typing slips (spaces, capitals) rather
    // than rejecting them. Stripe reports a code that is actually wrong.
    CardReaderComponent.prototype.normalizedRegistrationCode = function () {
        return this.registrationCode.trim().toLowerCase().replace(/\s*-\s*|\s+/g, '-');
    };
    CardReaderComponent.prototype.finishRegistrationForm = function () {
        this.isBusy = false;
        this.registrationCode = '';
        this.confirmedCampusId = null;
    };
    CardReaderComponent.prototype.resetForms = function () {
        this.errorMessage = '';
        this.justRegistered = false;
        this.confirmRemove = false;
        this.confirmReregister = false;
        this.registrationCode = '';
    };
    CardReaderComponent.prototype.failureMessage = function (error, fallback) {
        var data = error && error.response && error.response.data;
        return (data && data.message) || (error && error.message) || fallback;
    };
    CardReaderComponent.prototype.failureDetails = function (error) {
        var data = error && error.response && error.response.data;
        return (data && data.error && typeof data.error === 'object') ? data.error : {};
    };
    return CardReaderComponent;
}());
export { CardReaderComponent };
